import React, { useState, useEffect } from "react";
import Navbar from "../../../../../../../components/Navbar";
import Footer from "../../../../../../../components/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { verifyTableCode } from "../../../../../../../api/user/restaurants";
import toast from "react-hot-toast";
import { useTranslation } from "../../../../../../../hooks/useTranslation";

const TableCode = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { reservation } = location.state || {};
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const navigate = useNavigate();

  useEffect(() => {
    if (reservation?.tableCode && reservation?._id) {
      const codeArray = reservation.tableCode.split("").slice(0, 6);
      setCode(codeArray);

      const timer = setTimeout(() => {
        handleVerify(codeArray);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [reservation]);

  const verifyCodeMutation = useMutation({
    mutationFn: (data) => verifyTableCode(data),
    onSuccess: () => {
      toast.success(t("tablecode").codeVerified);
      navigate(`/restaurantdetail`, {
        state: {
          restaurantId: reservation?.restaurantId,
          reservationId: reservation?._id,
        },
      });
    },
    onError: (err) => {
      toast.error(
        err?.response?.data?.message || t("tablecode").verificationFailed
      );
    },
  });

  const handleChange = (index, value) => {
    if (!/^[a-zA-Z0-9]?$/.test(value)) return;

    const updatedCode = [...code];
    updatedCode[index] = value.toUpperCase();

    setCode(updatedCode);

    if (value && index < code.length - 1) {
      const nextInput = document.getElementById(`code-${index + 1}`);
      if (nextInput) nextInput.focus();
    }

    if (!value && index > 0) {
      const prevInput = document.getElementById(`code-${index - 1}`);
      if (prevInput) prevInput.focus();
    }

    if (updatedCode.join("").length === 6) {
      handleVerify(updatedCode);
    }
  };

  // const handleVerify = (updatedcode) => {
  //   let code = "";
  //   if (updatedcode.length > 0) {
  //     code = updatedcode.join("");
  //   } else {
  //     code = code.join("");
  //   }

  //   if (code.length < 6) {
  //     toast.error(t("tablecode").invalidCodeError);
  //     return;
  //   }
  //   verifyCodeMutation.mutate({ tableCode: code });
  // };


  const handleVerify = (updatedcode) => {
    const finalCode = updatedcode?.join("") ?? "";

    if (finalCode.length < 6) {
      toast.error(t("tablecode").invalidCodeError);
      return;
    }

    verifyCodeMutation.mutate({ tableCode: finalCode });
  };


  return (
    <>
      <div className="lg:py-[100px] md:py-[70px] py-[30px]">
        <div className="container">
          <div className="w-full  max-w-[586px]  mx-auto">
            <form
              onSubmit={(e) => e.preventDefault()}
              className="w-full md:py-[40px] md:px-[25px] py-[25px] px-[15px] rounded-[10px] form-shadow"
            >
              <h2 className="md:text-[30px] text-[22px] font-medium text-center leading-[40px] placeholder:text-[#858585]">
                {t("tablecode").tableCode}
              </h2>
              <p className="text-center w-full max-w-[380px] text-lg leading-[30px] mx-auto mt-[9px] md:mb-[30px] mb-4">
                {t("tablecode").useCodeInstruction?.replace(
                  "{tableCode}",
                  reservation?.tableCode ?? ""
                )}
              </p>


              {/* <p className="text-center w-full max-w-[380px] text-lg leading-[30px] mx-auto mt-[9px] md:mb-[30px] mb-4">
                {t("tablecode").useCodeInstruction.replace(
                  "{tableCode}",
                  reservation?.tableCode
                )}
              </p> */}
              <div className="flex justify-center items-center md:gap-[22px] gap-2">
                {code.map((digit, index) => (
                  <input
                    key={index}
                    id={`code-${index}`}
                    type="text"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleChange(index, e.target.value)}
                    className="md:w-[68px] md:h-[57px] w-[40px] h-[40px] md:rounded-[15px] rounded-lg  outline-none border border-gray-300 text-[18px] placeholder:text-[#858585] text-center"
                  />
                ))}
              </div>

              <button
                onClick={() => handleVerify(code)}
                className="w-full rounded-[2px] bg-[#4CAF50] text-[18px] text-white font-semibold p-[19px] green-shadow hover:bg-[#209b25] md:mt-[45px] mt-[20px]"
              >
               {t("tablecode").verify} 
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default TableCode;
